function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M160,0C93.726,0,40,53.726,40,120v88c0.035,30.913,25.087,55.965,56,56h8v-16h-8c-22.08-0.026-39.974-17.92-40-40v-88 c0-57.438,46.562-104,104-104s104,46.562,104,104v88c-0.026,22.08-17.92,39.974-40,40h-8v16h8c30.913-0.035,55.965-25.087,56-56 v-88C280,53.726,226.274,0,160,0z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M65.928,377.032l5.848-9.208l-13.512-8.576l-5.848,9.216c-17.687,27.872-16.374,63.76,3.304,90.264V480h16v-24 c0.001-1.817-0.617-3.581-1.752-5C52.96,429.738,51.337,400.02,65.928,377.032z"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M440,0H336c-22.08,0.026-39.974,17.92-40,40v80c0.026,22.08,17.92,39.974,40,40h16v32 c-0.001,3.235,1.947,6.153,4.936,7.392c0.971,0.405,2.012,0.611,3.064,0.608c2.122,0,4.156-0.844,5.656-2.344L403.312,160H440 c22.08-0.026,39.974-17.92,40-40V40C479.974,17.92,462.08,0.026,440,0z M464,120c0,13.255-10.745,24-24,24h-40 c-2.122,0-4.156,0.844-5.656,2.344L368,172.688V152c0-4.418-3.582-8-8-8h-24c-13.255,0-24-10.745-24-24V40 c0-13.255,10.745-24,24-24h104c13.255,0,24,10.745,24,24V120z"
})));

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 336,
  y: 40,
  width: 56,
  height: 16
})));

var _ref6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 408,
  y: 40,
  width: 32,
  height: 16
})));

var _ref7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 336,
  y: 72,
  width: 104,
  height: 16
})));

var _ref8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 336,
  y: 104,
  width: 56,
  height: 16
})));

var _ref9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M267.584,368.464l-5.848-9.216l-13.512,8.576l5.848,9.216c14.592,22.985,12.969,52.701-4.04,73.96 c-1.135,1.419-1.753,3.183-1.752,5v24h16v-21.272C283.958,432.224,285.271,396.336,267.584,368.464z"
})));

var _ref10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M472,272h-72c-30.016,0.035-54.666,23.729-55.888,53.72L320,369.128V336c-0.035-30.913-25.087-55.965-56-56h-29.24 l-0.216-0.168L234.4,280H216c-8.837,0-16-7.163-16-16v-18.824c24.719-14.272,39.962-40.633,40-69.176v-64 c-0.012-13.255-3.31-26.3-9.6-37.968c-2.015-3.712-6.569-5.219-10.4-3.44L84.592,134.304c-2.804,1.32-4.593,4.141-4.592,7.24V176 c0.038,28.543,15.281,54.904,40,69.176V264c0,8.837-7.163,16-16,16H56c-30.913,0.035-55.965,25.087-56,56v144h16V336 c0.026-22.08,17.92-39.974,40-40h25.456l72.04,100.656c1.48,2.069,3.856,3.31,6.4,3.344H160c2.518,0,4.889-1.186,6.4-3.2l76-100.8 H264c22.08,0.026,39.974,17.92,40,40v64c0.004,4.418,3.589,7.997,8.007,7.993c2.902-0.003,5.575-1.576,6.985-4.113L356.704,336 h45.864l-78,144h18.2L420.8,336h3.2c30.913-0.035,55.965-25.087,56-56C480,275.582,476.418,272,472,272z M96,176v-29.376 l123.528-58.128C222.483,95.98,224,103.954,224,112v64c0,35.346-28.654,64-64,64C124.654,240,96,211.346,96,176z M160.168,378.496 L135.48,344h50.688L160.168,378.496z M198.272,328H124l-22.904-32H104c17.673,0,32-14.327,32-32v-11.688 c15.622,4.917,32.378,4.917,48,0V264c0,17.673,14.327,32,32,32h6.4L198.272,328z M424,320h-63.2 c3.825-18.613,20.198-31.979,39.2-32h63.2C459.375,306.613,443.002,319.979,424,320z"
})));

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

var _ref20 = /*#__PURE__*/React.createElement("g", null);

var _ref21 = /*#__PURE__*/React.createElement("g", null);

var _ref22 = /*#__PURE__*/React.createElement("g", null);

var _ref23 = /*#__PURE__*/React.createElement("g", null);

var _ref24 = /*#__PURE__*/React.createElement("g", null);

var _ref25 = /*#__PURE__*/React.createElement("g", null);

var Svg002Support = function Svg002Support(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480 480",
    style: {
      enableBackground: "new 0 0 480 480"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg002Support, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/002-support.3440b552.svg";
export { ForwardRef as ReactComponent };